/** Map + analysis app shell for `/` — the only place that should compose `AnalysisPanel` / full map. */
import HomePage from '../features/main-dashboard/pages/HomePage';

export default function MainDashboard() {
  return <HomePage />;
}
